import { __assign, __generator } from "tslib";
import { call, put, select } from 'redux-saga/effects';
import { streamActions, withOffset } from '../../Stream';
import { request } from '../../xhr';
import { getCurrentMediaSource, getGallectionById, getCurrentFolderId, } from '../selectors';
import { getGallectionStreamId, getGallectionType } from '../helpers';
import { normalizeGallection } from '../../redux/normalizr/helpers';
export default function (action) {
    var _a, folderId, toFolderId, mediaSource, currentFolderId, gallection, streamId, updatedGallection, entities, moveToStreamId, params;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, folderId = _a.folderId, toFolderId = _a.toFolderId;
                return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                mediaSource = _c.sent();
                return [4 /*yield*/, select(getCurrentFolderId)];
            case 2:
                currentFolderId = _c.sent();
                return [4 /*yield*/, select(getGallectionById, folderId)];
            case 3:
                gallection = _c.sent();
                if (!gallection) {
                    return [2 /*return*/];
                }
                streamId = getGallectionStreamId(mediaSource, currentFolderId);
                return [4 /*yield*/, put(streamActions.deleteItem({ streamId: streamId, item: folderId }))];
            case 4:
                _c.sent();
                updatedGallection = __assign(__assign({}, gallection), { parentId: toFolderId !== null && toFolderId !== void 0 ? toFolderId : null });
                entities = normalizeGallection(updatedGallection);
                return [4 /*yield*/, put(streamActions.deleteItem({ streamId: streamId, item: folderId }))];
            case 5:
                _c.sent();
                moveToStreamId = getGallectionStreamId(mediaSource, toFolderId);
                return [4 /*yield*/, put(withOffset.actions.insertItems({
                        streamId: moveToStreamId,
                        items: [folderId],
                        offset: 0,
                        entities: entities,
                    }))];
            case 6:
                _c.sent();
                params = {
                    type: (_b = getGallectionType(mediaSource)) !== null && _b !== void 0 ? _b : 'collection',
                    folderid: folderId,
                    to_folderid: toFolderId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/move',
                        data: params,
                    })];
            case 7:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=moveGallection.js.map